import {useMutation} from 'react-query';
import postSendMessage from '.';
import {AxiosError} from 'axios';
import {toast} from 'react-toastify';

interface IPostMachineryRequirementProps {
  onSuccess?: () => void;
  guid?: string;
}

const usePostSendMesaage = ({
  guid,
  onSuccess,
}: IPostMachineryRequirementProps) => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: ISendMessagePayload) => {
      return postSendMessage(payload, guid);
    },
    onSuccess: data => {
      onSuccess && onSuccess();
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate, isSuccess};
};

export {usePostSendMesaage};
